// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnYFf6 {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  flex: 1;
  position: relative;
  z-index: 1;
}

.uEhp4J {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0 0 var(--spacing-4) 0;
}

.iCYpEw {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.X6y0GI {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.LqBHwy {
  position: relative;
  z-index: 9999;
}

.I5ks09 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-3);
  align-items: start;
}

.gboufG {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  color: var(--text-neutral-stronger);
  font-size: var(--font-size-md);
}

.aEi_Py {
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  cursor: pointer;
}

.X9_YVw {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-error);
  margin-top: var(--spacing-1);
  line-height: var(--line-height-160);
}

.HSc374 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  margin-top: var(--spacing-3);
}

.jAnfLh {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-2);
}

.Qwpkq1 {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.jGioeI {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  flex: 1;
}

.MqdotJ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.uAmBAS {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.WAMsNJ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.gyE_on {
  font-family: var(--font-family-base);
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--type-subtitle-md-font-weight);
  line-height: var(--type-subtitle-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.bgNPNu {
  display: flex;
  gap: var(--spacing-4);
}

.T0mKaI {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.T0mKaI input[type='radio'] {
  margin: 0;
  accent-color: var(--brand-tr-orange);
}

.T0mKaI span {
  user-select: none;
}

.NyFF7D {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.YnIg2B {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-3);
  align-items: start;
}

@media (max-width: 1248px) {
  .I5ks09,
  .YnIg2B {
    grid-template-columns: 1fr;
    gap: var(--spacing-4);
  }

  .bgNPNu {
    flex-direction: column;
    gap: var(--spacing-2);
  }

  .jAnfLh {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-3);
  }

  .OnYFf6 {
    gap: var(--spacing-3);
  }

  .iCYpEw {
    gap: var(--spacing-3);
  }

  .HSc374 {
    gap: var(--spacing-3);
    padding: var(--spacing-3);
    margin-top: var(--spacing-3);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesInformationForm/ChargesInformationForm.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,6CAA6C;EAC7C,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,gDAAgD;EAChD,gDAAgD;EAChD,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;EAC9B;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  flex: 1;\n  position: relative;\n  z-index: 1;\n}\n\n.title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0 0 var(--spacing-4) 0;\n}\n\n.formGrid {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.dateField {\n  position: relative;\n  z-index: 9999;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-3);\n  align-items: start;\n}\n\n.currencySymbol {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-neutral-stronger);\n  font-size: var(--font-size-md);\n}\n\n.calendarIcon {\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  cursor: pointer;\n}\n\n.errorMessage {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-error);\n  margin-top: var(--spacing-1);\n  line-height: var(--line-height-160);\n}\n\n.discountSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  margin-top: var(--spacing-3);\n}\n\n.discountToggle {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n}\n\n.discountDivider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.discountText {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  flex: 1;\n}\n\n.discountTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.discountMessage {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.discountFields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.discountTypeTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--type-subtitle-md-font-weight);\n  line-height: var(--type-subtitle-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.discountTypeOptions {\n  display: flex;\n  gap: var(--spacing-4);\n}\n\n.radioOption {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.radioOption input[type='radio'] {\n  margin: 0;\n  accent-color: var(--brand-tr-orange);\n}\n\n.radioOption span {\n  user-select: none;\n}\n\n.discountValueFields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4);\n}\n\n.discountValueRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-3);\n  align-items: start;\n}\n\n@media (max-width: 1248px) {\n  .row,\n  .discountValueRow {\n    grid-template-columns: 1fr;\n    gap: var(--spacing-4);\n  }\n\n  .discountTypeOptions {\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\n  .discountToggle {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-3);\n  }\n\n  .container {\n    gap: var(--spacing-3);\n  }\n\n  .formGrid {\n    gap: var(--spacing-3);\n  }\n\n  .discountSection {\n    gap: var(--spacing-3);\n    padding: var(--spacing-3);\n    margin-top: var(--spacing-3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OnYFf6`,
	"title": `uEhp4J`,
	"formGrid": `iCYpEw`,
	"field": `X6y0GI`,
	"dateField": `LqBHwy`,
	"row": `I5ks09`,
	"currencySymbol": `gboufG`,
	"calendarIcon": `aEi_Py`,
	"errorMessage": `X9_YVw`,
	"discountSection": `HSc374`,
	"discountToggle": `jAnfLh`,
	"discountDivider": `Qwpkq1`,
	"discountText": `jGioeI`,
	"discountTitle": `MqdotJ`,
	"discountMessage": `uAmBAS`,
	"discountFields": `WAMsNJ`,
	"discountTypeTitle": `gyE_on`,
	"discountTypeOptions": `bgNPNu`,
	"radioOption": `T0mKaI`,
	"discountValueFields": `NyFF7D`,
	"discountValueRow": `YnIg2B`
};
module.exports = ___CSS_LOADER_EXPORT___;
